import { render, staticRenderFns } from "./datatables_curriculum_participant.vue?vue&type=template&id=4d1477ae&"
import script from "./datatables_curriculum_participant.vue?vue&type=script&lang=js&"
export * from "./datatables_curriculum_participant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports